import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { LocalStorage } from '@vectord/utils';
import { AutomationListColumns } from 'automations/data/automationList';
import { type AutomationListProps } from 'automations/services/automationListService';

const lsInstance = LocalStorage.getInstance('automations.store.automationList');

export interface AutomationListState {
  sortOptions: AutomationListProps['sortOptions'];
  filterOptions: AutomationListProps['filterOptions'];
}

const initialState: AutomationListState = {
  sortOptions: {
    sortField: AutomationListColumns.ModifiedOn,
    sortOrder: 'asc',
  },
  filterOptions: {},
};

const savedConfig: AutomationListState = lsInstance?.config;

export const automationListSlice = createSlice({
  name: 'automationList',
  initialState: { ...initialState, ...savedConfig },
  reducers: {
    setSortOptions: (state, action: PayloadAction<{
      sortField: string;
      sortOrder: 'ascend' | 'descend';
    }>) => {
      state.sortOptions = {
        sortField: action.payload.sortField,
        sortOrder: action.payload.sortOrder === 'ascend' ? 'asc' : 'desc',
      };
    },
    setFilterOptions: (state, action: PayloadAction<AutomationListProps['filterOptions']>) => {
      state.filterOptions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('automationList/'),
      (state) => { lsInstance.config = state; },
    );
  },
});

export const {
  setSortOptions,
  setFilterOptions,
} = automationListSlice.actions;

export default automationListSlice.reducer;
